module.exports = __webpack_public_path__ + "static/img/13.7509297.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/sp/13.png
// module id = H+tF
// module chunks = 0